import type { SVGProps } from "react";
export interface BowlHotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BowlHotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BowlHotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.664.926a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.004-.006 0-.02.037a.17.17 0 0 0 0 .121l.3.737.078.219c.309 1.03-.1 2.204-1.073 2.75l-.217.107-.035.015-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.036a.2.2 0 0 0 .01-.061l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.212-3.077l.034-.013.109-.04Zm5.392.041a1.125 1.125 0 1 1 .889 2.066l-.034.014c.008-.003-.008 0-.022.037a.17.17 0 0 0 .002.121l.301.737c.441 1.078.046 2.384-.997 2.97l-.217.106-.034.015a1.125 1.125 0 0 1-.889-2.067l.034-.014.022-.036a.17.17 0 0 0-.002-.123l-.301-.736c-.47-1.15.01-2.559 1.214-3.077zm5.499 0a1.125 1.125 0 0 1 .89 2.066l-.035.014c.01-.004-.006-.001-.02.037a.17.17 0 0 0 .001.121l.3.737.078.219c.308 1.03-.1 2.204-1.074 2.75l-.216.107-.034.015-.109.041a1.126 1.126 0 0 1-.78-2.108l.033-.014.02-.036a.2.2 0 0 0 .012-.061l-.011-.062-.302-.736c-.47-1.15.01-2.559 1.213-3.077zm3.951 7.908c.834 0 1.546.639 1.614 1.48l.005.17c-.043 1.853-.31 3.45-.841 4.732a11.1 11.1 0 0 1-2.414 3.61 11.1 11.1 0 0 1-2.916 2.09v.042a2.126 2.126 0 0 1-2.125 2.126H9.172a2.126 2.126 0 0 1-2.126-2.126v-.04a11.1 11.1 0 0 1-2.916-2.092 11.1 11.1 0 0 1-2.192-3.109l-.22-.5c-.466-1.123-.73-2.485-.817-4.05l-.026-.682a1.62 1.62 0 0 1 1.62-1.651zM3.15 11.125c.08 1.375.308 2.457.645 3.27A8.88 8.88 0 0 0 8.602 19.2c.42.174.694.585.694 1.04v.636h5.409v-.636c0-.455.273-.866.694-1.04a8.88 8.88 0 0 0 4.806-4.803c.337-.814.564-1.897.643-3.271z"
      />
    </svg>
  );
}
